import { find, forEach, map } from 'lodash'
import { produce } from 'immer'
import { SiteData } from '../apis/site.api'
import permissionService from './permission.service'
import { ActionName } from '../components/Actions'
import { TableHorizontalData } from '../components/TableHorizontal'

export default {
  tableHorizontalData (sites: SiteData[]): TableHorizontalData<SiteData>[] {
    forEach(sites, (site: TableHorizontalData<SiteData>) => {
      const actions: ActionName[] = ['edit']
      const action: ActionName = site.isBlocked ? 'start' : 'resume'
      actions.push(action)
      site.actions = actions
      if (!site.permissions) return
      const permissionNames = permissionService.listNames(site.permissions)
      site.permissionNames = permissionNames.join(', ')
    })
    return sites
  },

  block (sites: TableHorizontalData<SiteData>[], id: number) {
    return produce(sites, sites => {
      const site = find(sites, { id })
      if (!site || !site.actions) return
      site.actions.splice(1, 1, 'start')
    })
  },

  unblock (sites: TableHorizontalData<SiteData>[], id: number) {
    return produce(sites, sites => {
      const site = find(sites, { id })
      if (!site || !site.actions) return
      site.actions.splice(1, 1, 'resume')
    })
  },

  selectOptions (sites: SiteData[]) {
    return map(sites, site => {
      const { name, id } = site
      return { name, value: String(id) }
    })
  }
}
